module.exports = __webpack_public_path__ + "static/img/8.0933b18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/01/8.png
// module id = driU
// module chunks = 1